module.exports = __webpack_public_path__ + "static/media/test1_2.626545c3.png";